import { render } from "./PlayerDetails.vue?vue&type=template&id=a24b933a&scoped=true"
import script from "./PlayerDetails.vue?vue&type=script&lang=ts"
export * from "./PlayerDetails.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-a24b933a"

export default script